import $ from 'jquery';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker';

class Daterange {
  #daterangeInput;

  constructor(daterangeInput) {
    this.#daterangeInput = daterangeInput;
  }

  init() {
    $(this.#daterangeInput).daterangepicker({
      showDropdowns: true,
      autoApply: true,
      ranges: {
          'Gestern': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Letzten 7 Tage': [moment().subtract(6, 'days'), moment().subtract(1, 'days')],
          'Letzten 30 Tage': [moment().subtract(29, 'days'), moment().subtract(1, 'days')],
          'Diesen Monat': [moment().startOf('month'), moment().subtract(1, 'days')],
          'Letzten Monat': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      minDate: moment('2024-01-01'),
      maxDate: moment().subtract(1, 'days'),
      locale: {
          format: 'DD.MM.YYYY',
          separator: ' - ',
          applyLabel: 'Ok',
          cancelLabel: 'Abbrechen',
          fromLabel: 'Von',
          toLabel: 'Bis',
          customRangeLabel: 'Benutzerdef.',
          weekLabel: 'W',
          daysOfWeek: [
              'So',
              'Mo',
              'Di',
              'Mi',
              'Do',
              'Fr',
              'Sa'
          ],
          monthNames: [
              'Januar',
              'Februar',
              'März',
              'April',
              'Mai',
              'Juni',
              'Juli',
              'August',
              'September',
              'Oktober',
              'November',
              'Dezember'
          ],
          firstDay: 1
      },
      startDate: typeof this.#daterangeInput.dataset.daterangeStart !== 'undefined' ? moment(this.#daterangeInput.dataset.daterangeStart) : moment().subtract(28, 'days'),
      endDate: typeof this.#daterangeInput.dataset.daterangeEnd !== 'undefined' ? moment(this.#daterangeInput.dataset.daterangeEnd) : moment(),
      drops: 'auto'
    }, (start, end) => {
      if (typeof this.#daterangeInput.dataset.daterangeStartHidden !== 'undefined') {
        const startDateHidden = document.querySelector(this.#daterangeInput.dataset.daterangeStartHidden);

        if (startDateHidden !== null) {
          startDateHidden.value = start.format('YYYY-MM-DD');
        }
      }

      if (typeof this.#daterangeInput.dataset.daterangeEndHidden !== 'undefined') {
        const endDateHidden = document.querySelector(this.#daterangeInput.dataset.daterangeEndHidden);

        if (endDateHidden !== null) {
          endDateHidden.value = end.format('YYYY-MM-DD');
        }
      }
    });
  }
}

export default Daterange;
